import { module } from 'modujs';
import formMixin from "../vue-mixins/formMixin";

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        //Initial values are used to prefill the form.
        this.initialValues = JSON.parse(this.getData('values'))
        // Init vue
        this.initVue()
    }

    initVue() {
        /////////////////////////
        // Save moduleInstance
        const moduleInstance = this

        /////////////////////////
        // Settings
        Vue.config.devtools = true

        /////////////////////////
        // Import vuelidate
        Vue.use(window.vuelidate.default)
        const { required, email } = window.validators

        /////////////////////////
        // Vue Instance
        this.app = new Vue({

            el: this.el,

            delimiters: ['${', '}'],

            mixins: [formMixin],

            data: () => {
                return {
                    submitStatus: '',
                    lastname: "",
                    firstname: "",
                    email: '',
                    condition: ''
                }
            },

            validations: {
                lastname: {
                    required,
                },
                firstname: {
                    required,
                },
                email: {
                    required,
                    email
                }
            },

            created() {
                this.moduleInstance = moduleInstance
                // Set initial values
                this.moduleInstance.initialValues && this.setInitialValues(this.moduleInstance.initialValues)
            },

            methods: {
                setInitialValues(values) {
                    const objKeys = Object.keys(values)
                    const objValues = Object.values(values)
                    objKeys.forEach((objKey, index) => {
                        if (this[objKey] != undefined) {
                            this[objKey] = objValues[index]
                        }
                    })
                }
            }
        })
    }

    destroy() {
        super.destroy();

        if (this.app) {
            this.app.$destroy();
        }
    }
}
